import { DateUtils } from '../../utils';

export const isValidAccommodationSearch = (currentAccommodationSearch) => {
    const hasDestination = Boolean(currentAccommodationSearch?.destination && Object.keys(currentAccommodationSearch.destination).length > 0);
    const hasValidDates = Boolean(DateUtils.isValidDate(DateUtils.parse(currentAccommodationSearch?.dates?.checkin)) &&
        DateUtils.parse(currentAccommodationSearch?.dates?.checkout));
    const hasRooms = Boolean(Array.isArray(currentAccommodationSearch?.rooms) && currentAccommodationSearch.rooms.length > 0);

    return hasDestination && hasValidDates && hasRooms;
};
